// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"b4339dd985fac57e","5285":"6a0049862a2bd4d9"}[chunkId] + ".css";
};